import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/52b1d5ee-8349-4337-9307-fede2e23d73a";
export const REGISTER_URL = "https://a.ntrk2.com/0e1c0171-07c8-4d2e-a615-05dee9c836c9";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://jetph.kzw2a.com/download?openExternalBrowser=1&id=4yp4rted3j0frhm";

export * from "./codes";
export * from "./context";
